// extracted by mini-css-extract-plugin
module.exports = {"loader":"ProgressBox_loader__SgZ3w","content":"ProgressBox_content__3a04q"};